(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('OltService', OltService);

    OltService.$inject = ['$http', '$q', 'RequestService', 'ModalConstructor', 'AlertModalService', 'cfpLoadingBar', 'OltData'];

    function OltService($http, $q, RequestService, ModalConstructor, AlertModalService, cfpLoadingBar, OltData) {

        return {
            // Api Methods
            listOlts: listOlts,
            getOlt: getOlt,
            getOltDetail: getOltDetail,
            addOlt: addOlt,
            updateOlt: updateOlt,
            updateOltDateTime: updateOltDateTime,
            deleteOlts: deleteOlts,
            restartOlts: restartOlts,
            resetOlt: resetOlt,
            uploadFilesToOlt: uploadFilesToOlt,
            uploadTftpFileToOlt: uploadTftpFileToOlt,
            setGtpCpeMgrId: setGtpCpeMgrId,
            // Backup methods
            backupOlts: backupOlts,
            getBackupOlt: getBackupOlt,
            restoreOltBackup: restoreOltBackup,
            // Ports method
            getAllPorts: getAllPorts,
            // History chart method
            getHistory: getHistory,
            // Firmware update methods
            getFiles: getFiles,
            updateOltFirmware: updateOltFirmware,
            // Modal Methods
            addOltModalConstructor: addOltModalConstructor,
            editOltModalConstructor: editOltModalConstructor,
            confirmationOltModalConstructor: confirmationOltModalConstructor,
            errorModalConstructor: errorModalConstructor,
            successModalConstructor: successModalConstructor,
            warningModalConstructor: warningModalConstructor,
            optionRestoreModalConstructor: optionRestoreModalConstructor,
            restoreModalConstructor: restoreModalConstructor,
            updateFirmwareOnuModalConstructor: updateFirmwareOnuModalConstructor,
            gtpCpeMgrModalConstructor: gtpCpeMgrModalConstructor,
            waitModalConstructor: waitModalConstructor,
            uploadFilesTftpModalConstructor: uploadFilesTftpModalConstructor,
            restoreBackupOltModalConstructor: restoreBackupOltModalConstructor,
            restoreOltToFile: restoreOltToFile,
            restoreOltToFileName: restoreOltToFileName,
            abreModalAlarmShowConstructor: abreModalAlarmShowConstructor,
            setAutoConfig: setAutoConfig

        };

        // Api Methods
        function listOlts(data, hideSpinner) {
            return $http.get(oltApi(), {params: listParams(data), ignoreLoadingBar: !!hideSpinner}).then(responseData);
        }

        function getOlt(oltId) {
            return $http.get(oltApi(oltId)).then(responseData);
        }

        function getOltDetail(oltId) {
            return $http.get(oltApi(oltId + '/details'), {ignoreLoadingBar: true}).then(responseData);
        }

        function addOlt(data) {
            return $http.post(oltApi(), data).then(responseData);
        }

        function updateOlt(data) {
            return $http.put(oltApi(), data).then(responseData);
        }

        function updateOltDateTime(oltId, data) {
            return $http.put(oltApi(oltId + '/setdatetime'), data, {ignoreLoadingBar: true}).then(responseData);
        }

        function deleteOlts(oltData) {
            var oltIds = oltData.map(oltId);
            return $http.delete(oltApi(oltIds));
        }

        function restartOlts(oltData) {
            var oltIds = oltData.map(oltId);
            return $http.put(oltApi(oltIds + '/restart')).then(responseData);
        }

        function resetOlt(oltData) {
            var oltIds = oltData.map(oltId);
            return $http.put(oltApi(oltIds + '/reset'), null, {ignoreLoadingBar: true}).then(responseData);
        }

        function uploadFilesToOlt(data) {
            return $http
                    .put(oltApi(data.oltId + '/loadfiles'), uploadDataConfig(data), {
                        headers: {
                            'Content-Type': undefined
                        },
                        ignoreLoadingBar: true
                    })
                    .then(responseData);
        }

        function uploadFilesTftpModalConstructor(oltId) {
            var modal = {
                templateUrl: 'app/components/olt/olt-upload-tftp.html',
                controller: 'OltUploadTftpController',
                controllerAs: 'vmOltUploadTftp',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    oltId: function () {
                        return oltId
                    },
                }
            };
            ModalConstructor.open(modal);
        }

        function restoreBackupOltModalConstructor(oltId) {
            var modal = {
                templateUrl: 'app/components/olt/olt-restore-backup.html',
                controller: 'OltRestoreBackupController',
                controllerAs: 'vmOltRestoreBackup',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    oltId: function () {
                        return oltId
                    },
                }
            };
            ModalConstructor.open(modal);
        }

        function uploadTftpFileToOlt(data) {
            return $http.put(oltApi(data.oltId + '/' + data.fileName + '/loadTftpfileName')).then(responseData);
        }

        function restoreOltToFileName(data) {
            return $http.put(oltApi(data.oltId + '/' + data.fileName + '/restoreFileName')).then(responseData);
        }

        function restoreOltToFile(data) {
            console.log('enviando');
            //return $http.put(oltApi(data.oltId + '/' + data.fileName + '/restoreFile')).then(responseData);
            var formData = new FormData();
            formData.append('file', data.file);
            return $http
                    .put(oltApi(data.oltId + '/restoreFile'), formData, {
                        headers: {
                            'Content-Type': undefined
                        },
                        ignoreLoadingBar: true
                    })
                    .then(responseData);
        }

        function backupOlts(oltData) {
            var oltIds = oltData.map(oltId);
            return $http.post(oltApi(oltIds + '/backup')).then(responseData);
        }

        function getBackupOlt(oltId) {
            return $http.get(oltApi(oltId + '/backup')).then(responseData);
        }

        function restoreOltBackup(data) {
            return $http.put(oltApi(data[0].oltId + '/restore/' + data[0].oltBackupId)).then(responseData);
        }

        function getAllPorts(oltId) {
            return $http.get(portApi(oltId), {ignoreLoadingBar: true}).then(responseData);
        }

        function getHistory(oltId) {
            return $http.get(historyApi(oltId), {ignoreLoadingBar: true}).then(responseData);
        }

        function getFiles(oltId) {
            return $http.get(oltApi('oltfiles/' + oltId)).then(responseData);
        }

        function updateOltFirmware(data) {
            data = data[0]
            return $http.put(oltApi('fwupdate'), data).then(responseData);
        }

        function setGtpCpeMgrId(data) {
            return $http.put(oltApi('gtpcpemgr'), data).then(responseData);
        }

        // Modal Methods
        function addOltModalConstructor() {
            var modal = oltModalConfig();
            ModalConstructor.open(modal);
        }

        function editOltModalConstructor(oltId, scope) {
            var modal = oltModalConfig();
            modal.scope = scope;
            modal.resolve.oltId = oltId;
            ModalConstructor.open(modal);
        }

        function confirmationOltModalConstructor(oltsData, dataAction) {
            var confirmOlt = {
                templateUrl: 'app/components/olt/olt-confirm.html',
                controller: 'OltConfirmController',
                controllerAs: 'vmOltConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    oltList: function () {
                        return oltsData;
                    }
                },
                avoidCancel: true
            };
            ModalConstructor.open(confirmOlt);
        }

        function errorModalConstructor(response, action) {
            var modalInstance = AlertModalService.error(response, action, 'olt');
            if (response.status == 404) {
                if (action == 'detail') {
                    removeOlts();
                } else {
                    modalInstance.closed.then(removeOlts);
                }
            }
            function removeOlts() {
                var oltList = OltData.detail ? [OltData.detail] : OltData.selected;
                OltData.removeOlts(oltList);
            }
        }

        function successModalConstructor(action, isMultiple, isNotCloseModal) {
            return AlertModalService.success(action, isMultiple, 'olt', isNotCloseModal);
        }

        function warningModalConstructor(list, response, action) {
            AlertModalService.warning(list, response, action, 'olt');
        }

        function optionRestoreModalConstructor() {
            var modal = {
                templateUrl: 'app/components/olt/olt-option-restore.html',
                controller: 'OltOptionRestoreController',
                controllerAs: 'vmOltOptionRestore',
                size: 'sm',
                backdrop: 'static'
            };
            ModalConstructor.open(modal);
        }

        //TODO regilson aqui abre o popup
        function restoreModalConstructor() {
            alert('aqui abre o popup');
            var modal = {
                templateUrl: 'app/components/olt/olt-restore.html',
                controller: 'OltRestoreController',
                controllerAs: 'vmOltRestore',
                size: 'lg',
                backdrop: 'static'
            };
            ModalConstructor.open(modal);
        }

        function updateFirmwareOnuModalConstructor(oltId) {
            var modal = {
                templateUrl: 'app/components/olt/olt-update-firmware.html',
                controller: 'OltUpdateFirmwareController',
                controllerAs: 'vmOltUpdateFirmware',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    oltId: function () {
                        return oltId
                    },
                }
            };
            ModalConstructor.open(modal);
        }

        function gtpCpeMgrModalConstructor(oltId, scope, showMessage) {
            var modal = oltModalGtpCpeMgrConfig();
            var modalInstance = null;
            modal.scope = scope;
            modal.resolve.oltId = oltId;
            modal.resolve.showMessage = showMessage;
            modalInstance = ModalConstructor.open(modal);
            return modalInstance;
        }

        // Api functions
        function oltApi(method) {
            return RequestService.apiUrl('olts', method);
        }

        function portApi(method) {
            return RequestService.apiUrl('ports', method);
        }

        function historyApi(method) {
            return RequestService.apiUrl('history', method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        // Helper functions
        function oltId(item) {
            return item.id;
        }

        function listParams(data) {
            var params = {};
            OltData.setSearch(false);
            if (data) {
                OltData.setSearch(true);
                if (data.name) {
                    params.name = data.name;
                }
                if (data.ip) {
                    params.ip = data.ip;
                }
            }
            return params;
        }

        function uploadDataConfig(data) {
            var formData = new FormData();
            var lengthArrayFiles = data.files.length;
            for (var i = 0; i < lengthArrayFiles; i++) {
                formData.append('file', data.files[i]);
            }
            return formData;
        }

        function oltModalConfig() {
            return {
                templateUrl: 'app/components/olt/olt-add.html',
                controller: 'OltAddController',
                controllerAs: 'vmOltAdd',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    oltId: null,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('olt-modals');
                            $translatePartialLoader.addPart('olt');
                            return $translate.refresh();
                        }]
                }
            };
        }

        function oltModalGtpCpeMgrConfig() {
            return {
                templateUrl: 'app/components/olt/olt-gtp-cpe-mgr.html',
                controller: 'OltGtpCpeMgrController',
                controllerAs: 'vmOltGtpCpeMgr',
                size: 'sm',
                backdrop: 'static',
                avoidCancel: true,
                resolve: {
                    oltId: null,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('olt-modals');
                            $translatePartialLoader.addPart('olt');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                }
            };
        }

        function waitModalConstructor(activity, action) {
            return AlertModalService.wait(activity, action);
        }

        function abreModalAlarmShowConstructor() {
            var modal = {
                templateUrl: 'app/components/alarm/alarm-show.html',
                controller: 'AlarmShowController',
                controllerAs: 'alarmShowVm',
                size: 'lg',
                backdrop: 'static',
                windowClass: 'modal-console'
            };
            ModalConstructor.open(modal);
        }

        function setAutoConfig(data) {
            return $http.put(oltApi('autoConfig'), data).then(responseData);
        }

    }
})();
